<template>
  <div class="px-20 py-20 border-box">
    <el-card shadow="never" header="员工档案">
      <div slot="header">
        <span>员工档案</span>
        <span class="ml-10 c-tip">按员工聚合劳动合同，评估用工风险</span>
      </div>
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #riskSlot="{ row }">
          <el-tag :type="riskTag(row.risk)">{{ riskText(row.risk) }}</el-tag>
        </template>
        <template #renewSlot="{ row }">
          <el-tag v-if="row.hasRenewed" type="info">含已续签{{ row.renewedCount > 1 ? '(' + row.renewedCount + ')' : '' }}</el-tag>
          <span v-else>—</span>
        </template>
      </tableComponent>
    </el-card>
  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import { pageForEmployeeApi } from '@/api/laborContract/index'

export default {
  name: 'LaborEmployees',
  components: { tableComponent },
  data() {
    return {
      loading: false,
      dataList: [],
      columns: [
        { id: 0, title: '序号', isSort: false, width: '60px', keyName: 'i', align: 'center', slotName: '' },
        { id: 1, title: '员工姓名', isSort: false, width: '120px', keyName: 'employeeName', align: 'center', slotName: '' },
        { id: 2, title: '部门', isSort: false, width: '140px', keyName: 'dept', align: 'center', slotName: '' },
        { id: 3, title: '岗位', isSort: false, width: '140px', keyName: 'post', align: 'center', slotName: '' },
        { id: 4, title: '合同数', isSort: false, width: '90px', keyName: 'contractCount', align: 'center', slotName: '' },
        { id: 5, title: '最近到期', isSort: false, width: '140px', keyName: 'nearestEnd', align: 'center', slotName: '' },
        { id: 6, title: '风险等级', isSort: false, width: '110px', keyName: 'risk', align: 'center', slotName: 'riskSlot' },
        { id: 7, title: '续签情况', isSort: false, width: '120px', keyName: 'hasRenewed', align: 'center', slotName: 'renewSlot' }
      ],
      pagination: { pageCount: 7, total: 0, pageSize: 10, pageSizes: [10, 20, 100] }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() { this.initData() },
    initData(item = {}) {
      const params = { pageNum: '1', pageSize: '10', query: {}, ...item }
      this.loading = true
      pageForEmployeeApi(params).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.dataList = res.data.rows
          this.pagination.total = res.data.total
        }
      })
    },
    childSizeChange(page) { this.initData({ pageSize: page }) },
    childCurrentChange(value) { this.initData({ pageNum: value }) },
    riskText(r) { return ['低', '中', '高'][r] || '低' },
    riskTag(r) { return ['success', 'warning', 'danger'][r] || 'success' }
  }
}
</script>
